import React from 'react';

const COLORS = {
  ok: '#10b759',
  warning: '#fd7e14',
  critical: '#dc3545',
  unknown: '#cbd5e1',
};

const LABELS = {
  ok: 'OK',
  warning: 'Atención',
  critical: 'Crítico',
  unknown: 'Sin datos',
};

export function healthColor(estado) {
  return COLORS[estado] || COLORS.unknown;
}

export default function HealthBadge({ estado = 'unknown', size = 10, showLabel = true, label }) {
  const color = healthColor(estado);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, verticalAlign: 'middle' }}>
      <span
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: color,
          boxShadow: `0 0 0 2px ${color}33`,
          display: 'inline-block',
          flexShrink: 0,
        }}
      />
      {showLabel ? (
        <span style={{ fontSize: 12, color: '#596882', fontWeight: 600 }}>
          {label || LABELS[estado] || estado}
        </span>
      ) : null}
    </span>
  );
}
